module.exports = __webpack_public_path__ + "static/media/Instagram icon.cd2b8f3c.svg";